
export class FinancialItemSearchCriteriaDtoModel {

  limit?: number;
  calcTotalRecords?: boolean;
  offset?: number;
  order?: string;
  snapshot?: string;
  entity_hdr_guids?: any[];
  label_hdr_1_guids?: any[];
  label_hdr_2_guids?: any[];
  label_hdr_3_guids?: any[];
  label_hdr_4_guids?: any[];
  label_hdr_5_guids?: any[];
  label_hdr_6_guids?: any[];
  label_hdr_7_guids?: any[];
  label_hdr_8_guids?: any[];
  label_hdr_9_guids?: any[];
  label_hdr_10_guids?: any[];
  label_hdr_11_guids?: any[];
  pricing_scheme_hdr_guids?: any[];
  status?: string;
  search_word?: string;
  }
  